import { COLORS } from 'Components/utils/color/colors';

export const themes = {
  none: {
    thDefaultColor: 'current',
    thTitle: '',
    thIcon: '',
  },
  'title-brand-1': {
    thDefaultColor: COLORS.BLUE,
    thTitle:
      'flex items-center justify-center font-brand font-normal leading-tight text-center text-xl md:text-2xl',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-2': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-brand font-normal leading-tight text-xl lg:text-2xl',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-3': {
    thDefaultColor: COLORS.BLUE,
    thTitle: 'flex items-center font-brand font-normal leading-tight text-lg',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-4': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle:
      'border-b-1 border-gray-light flex items-center justify-center font-brand font-normal leading-tight pb-2 text-lg',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-5': {
    thDefaultColor: COLORS.BLUE,
    thTitle: 'border-b-1 border-gray-light flex items-center font-brand leading-tight pb-1 text-xl',
    thIcon: 'rtl:mr-2 mb-1',
  },
  'title-brand-6': {
    thDefaultColor: COLORS.BLUE,
    thTitle:
      'border-b-1 border-current decorator-losange flex items-center justify-center font-brand font-normal leading-tight pb-2 text-3xl',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-7': {
    thDefaultColor: COLORS.BLUE,
    thTitle: 'flex items-center font-brand font-normal leading-tight text-lg',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-9': {
    thDefaultColor: COLORS.BLUE,
    thTitle: 'text-center md:text-initial leading-tight text-xl font-brand font-normal',
    thIcon: 'rtl:mr-2',
  },
  'title-brand-10': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle:
      'flex font-brand font-normal items-baseline leading-tight text-2xl sm:text-3xl text-initial',
    thIcon: 'self-center rtl:mr-2',
  },
  'title-brand-11': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle:
      'flex font-brand font-normal items-baseline leading-tight text-xl sm:text-2xl text-initial',
    thIcon: 'self-center rtl:mr-2',
  },
  'title-sans-1': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-normal text-base',
    thIcon: 'rtl:mr-1',
  },
  'title-sans-2': {
    thDefaultColor: COLORS.BLUE,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-xl uppercase',
    thIcon: 'rtl:mr-2',
  },
  'title-sans-3': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-md',
    thIcon: 'rtl:mr-1',
  },
  'title-sans-4': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-xl',
    thIcon: 'rtl:mr-2',
  },
  'title-sans-5': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-normal font-sans leading-tight text-sm',
    thIcon: 'rtl:mr-1',
  },
  'title-sans-6': {
    thDefaultColor: COLORS.PRUNE,
    thTitle: 'flex flex-col font-bold font-sans leading-tight text-xl uppercase',
    thIcon: 'mb-6',
    thIconSize: '4em',
  },
  'title-sans-7': {
    thDefaultColor: COLORS.PRUNE,
    thTitle: 'flex flex-col font-normal font-sans leading-tight text-lg',
    thIcon: 'mb-6',
    thIconSize: '4em',
  },
  'title-sans-8': {
    thDefaultColor: COLORS.BLUE,
    thTitle:
      'flex items-center justify-center font-bold font-sans leading-tight text-3xl sm:text-5xl text-center',
    thIcon: 'rtl:mr-4',
  },
  'title-sans-9': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-2xl',
    thIcon: 'rtl:mr-8',
  },
  'title-sans-10': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-sans leading-tight text-md',
    thIcon: 'rtl:mr-3',
  },
  'title-sans-11': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'decorator-dash flex items-center font-normal font-sans leading-tight text-md',
    thIcon: 'rtl:mr-1',
  },
  'title-sans-12': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-normal font-sans leading-tight text-md',
    thIcon: 'rtl:mr-1',
  },
  'title-sans-13': {
    thDefaultColor: COLORS.BLUE,
    thTitle:
      'flex items-center justify-center font-bold font-sans leading-tight text-xl sm:text-3xl text-center',
    thIcon: 'rtl:mr-4',
  },
  'title-serif-1': {
    thDefaultColor: COLORS.DEEP_BLUE,
    thTitle:
      'flex items-center justify-center font-bold font-serif leading-tight text-2xl lg:text-4xl',
    thIcon: 'rtl:mr-1',
  },
  'title-serif-2': {
    thDefaultColor: COLORS.DEEP_BLUE,
    thTitle:
      'flex items-center justify-center md:justify-start font-bold font-serif leading-tight text-2xl lg:text-4xl',
    thIcon: 'rtl:mr-1',
  },
  'title-serif-3': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle: 'flex items-center font-bold font-serif leading-tight text-md',
    thIcon: 'rtl:mr-1',
  },
  'title-serif-4': {
    thDefaultColor: COLORS.BLUE,
    thTitle: 'flex items-center font-bold font-serif leading-tight text-xl',
    thIcon: 'rtl:mr-1',
  },
  'title-serif-5': {
    thDefaultColor: COLORS.GRAY_DARKER,
    thTitle:
      'flex font-serif font-bold items-baseline leading-tight text-2xl sm:text-3xl text-initial',
    thIcon: 'self-center rtl:mr-2',
  },
  'title-serif-7': {
    thDefaultColor: COLORS.DEEP_BLUE,
    thTitle:
      'flex items-center justify-center font-serif font-normal leading-tight text-center text-xl md:text-2xl',
    thIcon: 'rtl:mr-2',
  },
};
